import * as React from 'react';
import { IconChevronRight16 } from '@cian/ui-kit/icons';
import * as styles from './RoundArrowRight.css';

interface IRoundArrowRightProps {
  onClick(): void;
}

export const RoundArrowRight: React.FC<IRoundArrowRightProps> = ({ onClick }) => {
  return (
    <div className={styles['arrow']} onClick={onClick}>
      <IconChevronRight16 color="gray_icons_100" />
    </div>
  );
};
